module.exports = __webpack_public_path__ + "img/model_02.8cd1bb36.jpg";